export const USER_DELETE = '/users/:userId'
export const USER_ROLE = '/users/:userId/role'
export const USERS = '/users'
export const USERS_ROLES = '/roles'
